import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';
import SCHOOL_TYPES from '@constants/schoolTypes';

// The age of the oldest child in the family, used to decide school/preschool wording
// when the schedule says the handover location is calculated on age.
export const schoolAgeFromFamily = (family:IFamilyMember[]):number => {
  let schoolAge:number = 1; // default school age
  const now:Date = new Date();
  for (const familyMember of family) {
    if (familyMember.role === FamilyMemberType.CHILD  && familyMember.yearBorn !== undefined
      && familyMember.yearBorn > 2000 && familyMember.yearBorn <= now.getFullYear()) {
      schoolAge = Math.max(now.getFullYear() - familyMember.yearBorn, schoolAge);
    }
  }
  return schoolAge;
};

// Resolves the schedule school setting to preschool or school.
// CALCULATED_ON_AGE (or a missing setting) falls back to the age of the oldest child.
export const isPreschool = (school:SCHOOL_TYPES|undefined, schoolAge:number|undefined):boolean => {
  if (school === SCHOOL_TYPES.PRESCHOOL) { return true; }
  if (school === SCHOOL_TYPES.SCHOOL) { return false; }
  return schoolAge !== undefined && schoolAge <= 6;
};



// WEBPACK FOOTER //
// ./src/helpers/schoolHelper.ts